module.exports = __webpack_public_path__ + "static/media/logo-prodigio.61fbbb50.svg";